import React from 'react'
import { useBoolean } from 'react-use'

import agent from 'agent'
import Button from 'components/common/Button'
import Row from 'components/Row'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const downloadConfigYamlFile = (currentTeamId) => {
  return new Promise<void>((resolve, reject) => {
    agent
      .get(`teams/client/install?teamId=${currentTeamId}`)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'config.yaml')
        link.click()
        window.URL.revokeObjectURL(url)
        return resolve()
      })
      .catch((err) => {
        toast({
          type: 'error',
          text: messageFromResponseError(
            err,
            'There was an issue downloading the config file. Please try again later.'
          )
        })
        reject(err)
      })
  })
}

export const ConfigYamlRow: React.FC<{ teamId: string }> = ({ teamId }) => {
  const [isSubmitting, setIsSubmitting] = useBoolean(false)

  return (
    <Row
      action={
        <Button
          primary
          disabled={isSubmitting}
          onClick={() => {
            setIsSubmitting(true)
            downloadConfigYamlFile(teamId).finally(() => setIsSubmitting(false))
          }}
        >
          Download
        </Button>
      }
      data-testid="download-config-yaml-row"
      label="Client Configuration File"
      value=" "
    />
  )
}
